export default "__VITE_ASSET__nEAADe6m__"